import { render, staticRenderFns } from "./materialSheet.vue?vue&type=template&id=b0003b68&scoped=true&"
import script from "./materialSheet.vue?vue&type=script&lang=js&"
export * from "./materialSheet.vue?vue&type=script&lang=js&"
import style0 from "./materialSheet.vue?vue&type=style&index=0&id=b0003b68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0003b68",
  null
  
)

export default component.exports